export enum OnboardingStatus {
    Merged = 1,
    ToBeOnboarded,
    OnboardedInMSA,
    OnboardedInLEAD,
    Duplicate,
    ToBeDeleted,
    ChildToMigrate,
    ChildMigrated,
    PromocodeProvider,
    Supporter
}